export const useConstAndReimbursement = () => {

    const calculate = function (contractMileage, projectedMileage, bracket1ExtraKmCost, bracket1KmReimbursement, bracket1Percentage, bracket2ExtraKmCost, bracket2KmReimbursement, bracket2Percentage, bracket3ExtraKmCost, bracket3KmReimbursement, bracket3Percentage, contractKmDeductible, initialMileage, maxReimbursementAmount) {

        contractMileage = parseInt(contractMileage);
        bracket1ExtraKmCost = parseFloat(bracket1ExtraKmCost);
        bracket1KmReimbursement = parseFloat(bracket1KmReimbursement);
        bracket1Percentage = parseFloat(bracket1Percentage);
        bracket2ExtraKmCost = parseFloat(bracket2ExtraKmCost);
        bracket2KmReimbursement = parseFloat(bracket2KmReimbursement);
        bracket2Percentage = parseFloat(bracket2Percentage);
        bracket3ExtraKmCost = parseFloat(bracket3ExtraKmCost);
        bracket3KmReimbursement = parseFloat(bracket3KmReimbursement);
        bracket3Percentage = parseFloat(bracket3Percentage);
        contractKmDeductible = parseInt(contractKmDeductible);
        initialMileage = parseInt(initialMileage);
        maxReimbursementAmount = parseInt(maxReimbursementAmount);

        const delta = calculateDelta(contractMileage, projectedMileage, contractKmDeductible, initialMileage);
        const bracketedDeltas = bracketizeDelta(delta, contractMileage, bracket2Percentage, bracket3Percentage);
        let bracketEconomics;

        if (delta <= 0) {
            bracketEconomics = [bracket1KmReimbursement, bracket2KmReimbursement, bracket3KmReimbursement];
        } else {
            bracketEconomics = [bracket1ExtraKmCost, bracket2ExtraKmCost, bracket3ExtraKmCost];
        }

        let costOrReimbursements = bracketedDeltas.map((v, i) => v * bracketEconomics[i]);
        let costOrReimbursement = costOrReimbursements.reduce((acc, val) => acc + val, 0);

        // console.info('||km forecast', projectedMileage, 'contractMileage', contractMileage, 'delta', delta, 'initialMileage', initialMileage, 'contractKmDeductible', contractKmDeductible, 'bracket1ExtraKmCost', bracket1ExtraKmCost, 'bracket1Percentage', bracket1Percentage, 'bracket2ExtraKmCost', bracket2ExtraKmCost, 'bracket2Percentage', bracket2Percentage, 'bracket3ExtraKmCost', bracket3ExtraKmCost, 'bracket3Percentage', bracket3Percentage)
        // console.info('||bracketedDeltas', bracketedDeltas, 'bracketEconomics', bracketEconomics, 'costOrReimbursements', costOrReimbursements);
        // console.info('||costOrReimbursement', costOrReimbursement, 'maxReimbursementAmount', maxReimbursementAmount);

        if (delta < 0 && !isNaN(maxReimbursementAmount) && maxReimbursementAmount != 0 && Math.abs(maxReimbursementAmount) < costOrReimbursement) {
            costOrReimbursement = Math.abs(maxReimbursementAmount);
        }

        if (delta < 0 && costOrReimbursement > 0) costOrReimbursement *= -1;

        return costOrReimbursement;
    }

    const bracketizeDelta = function(delta, contractMileage, bracket2Percentage, bracket3Percentage) {

        const delta2Bracket = contractMileage / 100 * (!isNaN(bracket2Percentage) ? bracket2Percentage : 0);
        const delta3Bracket = contractMileage / 100 * (!isNaN(bracket3Percentage) ? bracket3Percentage : 0);

        if (isNaN(bracket2Percentage)) {
            return [delta, 0, 0];
        } else if (Math.abs(delta) <= delta2Bracket && !isNaN(bracket2Percentage) && isNaN(bracket3Percentage)) {
            return [delta, 0, 0];
        } else if (Math.abs(delta) > delta2Bracket && !isNaN(bracket2Percentage) && isNaN(bracket3Percentage)) {
            return [delta2Bracket, Math.abs(delta) - delta2Bracket, 0];
        } else if (Math.abs(delta) <= delta3Bracket && !isNaN(bracket2Percentage) && !isNaN(bracket3Percentage)) {
            return [delta2Bracket, Math.abs(delta) - delta2Bracket, 0];
        } else if (Math.abs(delta) > delta3Bracket && !isNaN(bracket2Percentage) && !isNaN(bracket3Percentage)) {
            return [delta2Bracket, delta3Bracket, Math.abs(delta) - delta2Bracket - delta3Bracket];
        }
    }

    const calculateDelta = function (contractMileage, projectedMileage, contractKmDeductible, initialMileage) {

        let delta = (projectedMileage - contractMileage - (isNaN(initialMileage) ? 0 : initialMileage));

        if (delta <= 0) {
            // in caso di delta negativo NON applico la franchigia
            // // applico la franchigia, se vado in positivo, azzero.
            // delta -= (isNaN(contractKmDeductible) ? 0 : contractKmDeductible)
            // if (delta > 0) delta = 0;

        } else {
            // applico la franchigia, se vado in negativo, azzero.
            delta -= (isNaN(contractKmDeductible) ? 0 : contractKmDeductible)
            if (delta < 0) delta = 0;
        }

        if (isNaN(delta)) delta = 0;

        return delta;
    }

    return {
        calculate,
        calculateDelta
    }
};
